import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentsHeader: {
    id: 'checkoutPaymentsPlaceholder.paymentsHeader',
    defaultMessage: 'All transactions are safe and secure',
  },
  contactsHeader: {
    id: 'checkoutPaymentsPlaceholder.contactsHeader',
    defaultMessage: `Need help?`,
  },
  contactsText: {
    id: 'checkoutPaymentsPlaceholder.contactsText',
    defaultMessage: 'Contact us to order by phone',
  },
  ctaLabel: {
    id: 'checkoutPaymentsPlaceholder.ctaLabel',
    defaultMessage: 'Call Now',
  },
  paymentsSmallText: {
    id: 'checkoutPaymentsPlaceholder.paymentsSmallText',
    defaultMessage:
      '128-bit SSL encrypted payment. Breitling does not keep your payment details for your next orders.',
  },
});
